// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_attributes.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppAttributeSearchService } from "./app_attributes";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppAttributeServiceSearchResponse } from "./app_attributes";
import type { AppAttributeServiceSearchRequest } from "./app_attributes";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppAttributeSearchService
 */
export interface IAppAttributeSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search(c1.api.app.v1.AppAttributeServiceSearchRequest) returns (c1.api.app.v1.AppAttributeServiceSearchResponse);
     */
    search(input: AppAttributeServiceSearchRequest, options?: RpcOptions): UnaryCall<AppAttributeServiceSearchRequest, AppAttributeServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppAttributeSearchService
 */
export class AppAttributeSearchServiceClient implements IAppAttributeSearchServiceClient, ServiceInfo {
    typeName = AppAttributeSearchService.typeName;
    methods = AppAttributeSearchService.methods;
    options = AppAttributeSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search(c1.api.app.v1.AppAttributeServiceSearchRequest) returns (c1.api.app.v1.AppAttributeServiceSearchResponse);
     */
    search(input: AppAttributeServiceSearchRequest, options?: RpcOptions): UnaryCall<AppAttributeServiceSearchRequest, AppAttributeServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppAttributeServiceSearchRequest, AppAttributeServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
